import { PlusOutlined } from '@ant-design/icons'
import { BaseButton } from 'app/components/common/BaseButton'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { BaseInput } from 'app/components/common/inputs/BaseInput'
import { InputNumber } from 'app/components/common/inputs/InputNumber'
import {
  BaseModalComponent,
  IRefModal,
} from 'app/components/common/ModalComponent'
import { extractCoordinates } from 'app/hook'
import { getRandomUuid } from 'parkway-web-common'
import { useRef } from 'react'
import styled from 'styled-components'
import { useCreateEventContext } from '../../context'
import { ILocation } from '../../type'

export const ModalAddLocation = ({ index }: { index: number }) => {
  const { addLocationInActivityByIndex } = useCreateEventContext()
  const [form] = BaseForm.useForm<ILocation>()
  const modalRef = useRef<IRefModal>({})

  const openModal = () => {
    modalRef?.current?.open?.()
  }

  const handleSubmit = (values: ILocation) => {
    const { latitude, longitude } = extractCoordinates(values?.coordinates)

    addLocationInActivityByIndex?.(index, {
      ...values,
      lat: latitude,
      long: longitude,
      key_map_check_in: getRandomUuid(),
    })
    form?.resetFields()
    modalRef?.current?.hide?.()
  }

  return (
    <BaseModalComponent
      titleModal={'Thêm địa điểm'}
      handleSubmit={form?.submit}
      ref={modalRef}
      buttonOpenModal={
        <BaseButton icon={<PlusOutlined rev={undefined} />} onClick={openModal}>
          {'Thêm địa điểm'}
        </BaseButton>
      }
      renderContent={
        <BaseForm form={form} onFinish={handleSubmit}>
          <BaseForm.Item
            label={'Địa chỉ'}
            name={'address'}
            required
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập địa chỉ',
              },
            ]}
          >
            <BaseInput placeholder="Nhập địa chỉ" />
          </BaseForm.Item>

          <BaseForm.Item
            label={'Toạ độ'}
            name={'coordinates'}
            required
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập toạ độ',
              },
            ]}
          >
            <BaseInput placeholder="Nhập toạ độ checkin từ google map" />
          </BaseForm.Item>

          <BaseForm.Item
            label={'Bán kính (m)'}
            name={'radius'}
            required
            rules={[
              {
                required: true,
                message: 'Vui lòng nhập bán kính',
              },
            ]}
            initialValue={1}
          >
            <InputNumberWrapper min={1} placeholder="Nhập bán kính" />
          </BaseForm.Item>
        </BaseForm>
      }
    />
  )
}

const InputNumberWrapper = styled(InputNumber)`
  width: 100%;
`
